import React from 'react';

import { observer } from 'mobx-react';

import withDisplayName from 'bz-utilities/hoc/display-name';
import useComputed from 'bz-utilities/hooks/computed';

import { cache } from 'tm3-core/cache';

const ShellLogo = observer(
  withDisplayName((props) => {
    const url = useComputed(() => {
      if (cache.app.Caseflow) {
        return '/images/caseflow_logo.png';
      } else if (cache.app.PPM) {
        return '/images/ppm-logo-text.svg'
      }

      return cache.logoPath;
    }, []);

    return <img src={url} alt="logo" width="150" className="m-t-20 m-b-20" />;
  }, 'ShellLogo')
);

export default ShellLogo;
